import { devtools } from 'zustand/middleware'
import { create } from 'zustand'
import { pick } from 'lodash'
import { IModalStore, IModalState } from './type'
import { StoreSet, StoreGet } from 'project-config/types'
import { composeMiddleware } from 'project-config/utils'

const initialState = (): IModalState => ({
  open: false,
  type: undefined,
  size: undefined,
  title: undefined,
  render: undefined,
  closeOnClickOutside: undefined,
  themeType: undefined,
  confirmText: undefined,
  cancelText: undefined,
  confirmDisable: undefined,
  submitting: undefined,
  showClose: undefined,
  customCSS: undefined,
  onOk: () => undefined,
  onClose: () => undefined,
  titleBorderColor: undefined,
  titleFontSize: undefined,
  cssProperties: undefined,
  children: undefined,
})

const actions = (set: StoreSet<IModalStore>, get: StoreGet<IModalStore>) => ({
  showGlobalModal: (props: IModalState) => {
    const { updateModalProps, hideGlobalModal } = get()
    updateModalProps({
      ...initialState(),
      ...props,
      onClose: () => {
        void props.onClose?.()
        hideGlobalModal()
      },
      open: true,
    })
  },
  hideGlobalModal: () => set(() => initialState()),
  updateModalProps: (props: IModalState) =>
    set(() => ({
      ...props,
    })),
})

const getters = (get: StoreGet<IModalStore>) => ({
  getModalProps: () => pick(get(), Reflect.ownKeys(initialState())),
})

export const useModalStore = create<IModalStore>()(
  composeMiddleware([devtools], (set: StoreSet<IModalStore>, get: StoreGet<IModalStore>) => ({
    ...initialState(),
    ...actions(set, get),
    ...getters(get),
  })),
)
